import { LucideIcon, Wifi, Car, Waves, Utensils, Dumbbell, Sparkles, Wind, Users, Coffee, Tv, Refrigerator, Shield, Accessibility, Dog, Cigarette, Phone, Globe, ConciergeBell, PartyPopper, Baby, Shirt, MapPin, Briefcase, UtensilsCrossed } from 'lucide-react';

export interface Amenity {
  name: string;
  icon: LucideIcon;
  category: string;
}

export interface AmenityCategory {
  name: string;
  amenities: Amenity[];
}

// Map of keywords to amenities
const amenityKeywords: Record<string, { name: string; icon: LucideIcon; category: string }> = {
  // Internet & Connectivity
  'wifi': { name: 'Wi-Fi', icon: Wifi, category: 'Conectividad' },
  'wi-fi': { name: 'Wi-Fi', icon: Wifi, category: 'Conectividad' },
  'internet': { name: 'Internet', icon: Globe, category: 'Conectividad' },
  
  // Parking & Transportation
  'estacionamiento': { name: 'Estacionamiento', icon: Car, category: 'Transporte' },
  'estacionamento': { name: 'Estacionamiento', icon: Car, category: 'Transporte' },
  'parking': { name: 'Estacionamiento', icon: Car, category: 'Transporte' },
  'garaje': { name: 'Garaje', icon: Car, category: 'Transporte' },
  'garage': { name: 'Garaje', icon: Car, category: 'Transporte' },
  
  // Pool & Recreation
  'piscina': { name: 'Piscina', icon: Waves, category: 'Ocio' },
  'pool': { name: 'Piscina', icon: Waves, category: 'Ocio' },
  'alberca': { name: 'Piscina', icon: Waves, category: 'Ocio' },
  
  // Dining
  'restaurante': { name: 'Restaurante', icon: Utensils, category: 'Comida y bebida' },
  'restaurant': { name: 'Restaurante', icon: Utensils, category: 'Comida y bebida' },
  'bar': { name: 'Bar', icon: UtensilsCrossed, category: 'Comida y bebida' },
  'café': { name: 'Café', icon: Coffee, category: 'Comida y bebida' },
  'cafe': { name: 'Café', icon: Coffee, category: 'Comida y bebida' },
  'desayuno': { name: 'Desayuno', icon: Coffee, category: 'Comida y bebida' },
  'breakfast': { name: 'Desayuno', icon: Coffee, category: 'Comida y bebida' },
  
  // Fitness & Wellness
  'gimnasio': { name: 'Gimnasio', icon: Dumbbell, category: 'Bienestar' },
  'gym': { name: 'Gimnasio', icon: Dumbbell, category: 'Bienestar' },
  'academia': { name: 'Gimnasio', icon: Dumbbell, category: 'Bienestar' },
  'fitness': { name: 'Centro de fitness', icon: Dumbbell, category: 'Bienestar' },
  'spa': { name: 'Spa', icon: Sparkles, category: 'Bienestar' },
  'sauna': { name: 'Sauna', icon: Sparkles, category: 'Bienestar' },
  'masaje': { name: 'Masajes', icon: Sparkles, category: 'Bienestar' },
  'massage': { name: 'Masajes', icon: Sparkles, category: 'Bienestar' },
  
  // Room Amenities
  'aire acondicionado': { name: 'Aire acondicionado', icon: Wind, category: 'Habitación' },
  'air conditioning': { name: 'Aire acondicionado', icon: Wind, category: 'Habitación' },
  'ar condicionado': { name: 'Aire acondicionado', icon: Wind, category: 'Habitación' },
  'televisión': { name: 'TV', icon: Tv, category: 'Habitación' },
  'television': { name: 'TV', icon: Tv, category: 'Habitación' },
  'tv': { name: 'TV', icon: Tv, category: 'Habitación' },
  'minibar': { name: 'Minibar', icon: Refrigerator, category: 'Habitación' },
  'mini-bar': { name: 'Minibar', icon: Refrigerator, category: 'Habitación' },
  'nevera': { name: 'Nevera', icon: Refrigerator, category: 'Habitación' },
  'refrigerador': { name: 'Nevera', icon: Refrigerator, category: 'Habitación' },
  
  // Services
  'recepción 24': { name: 'Recepción 24h', icon: ConciergeBell, category: 'Servicios' },
  'reception 24': { name: 'Recepción 24h', icon: ConciergeBell, category: 'Servicios' },
  '24 horas': { name: 'Recepción 24h', icon: ConciergeBell, category: 'Servicios' },
  'recepcion': { name: 'Recepción', icon: ConciergeBell, category: 'Servicios' },
  'reception': { name: 'Recepción', icon: ConciergeBell, category: 'Servicios' },
  'conserjería': { name: 'Conserjería', icon: ConciergeBell, category: 'Servicios' },
  'concierge': { name: 'Conserjería', icon: ConciergeBell, category: 'Servicios' },
  'servicio de habitaciones': { name: 'Servicio de habitaciones', icon: ConciergeBell, category: 'Servicios' },
  'room service': { name: 'Servicio de habitaciones', icon: ConciergeBell, category: 'Servicios' },
  'lavandería': { name: 'Lavandería', icon: Shirt, category: 'Servicios' },
  'laundry': { name: 'Lavandería', icon: Shirt, category: 'Servicios' },
  'lavanderia': { name: 'Lavandería', icon: Shirt, category: 'Servicios' },
  
  // Security
  'seguridad': { name: 'Seguridad 24h', icon: Shield, category: 'Seguridad' },
  'security': { name: 'Seguridad 24h', icon: Shield, category: 'Seguridad' },
  'caja fuerte': { name: 'Caja fuerte', icon: Shield, category: 'Seguridad' },
  'safe': { name: 'Caja fuerte', icon: Shield, category: 'Seguridad' },
  
  // Accessibility
  'accesible': { name: 'Accesible', icon: Accessibility, category: 'Accesibilidad' },
  'accessible': { name: 'Accesible', icon: Accessibility, category: 'Accesibilidad' },
  'wheelchair': { name: 'Acceso silla de ruedas', icon: Accessibility, category: 'Accesibilidad' },
  
  // Pets & Smoking
  'mascotas': { name: 'Se admiten mascotas', icon: Dog, category: 'Políticas' },
  'pets': { name: 'Se admiten mascotas', icon: Dog, category: 'Políticas' },
  'animales': { name: 'Se admiten mascotas', icon: Dog, category: 'Políticas' },
  'no fumar': { name: 'No fumadores', icon: Cigarette, category: 'Políticas' },
  'non-smoking': { name: 'No fumadores', icon: Cigarette, category: 'Políticas' },
  
  // Family
  'niños': { name: 'Apto para niños', icon: Baby, category: 'Familiar' },
  'children': { name: 'Apto para niños', icon: Baby, category: 'Familiar' },
  'kids': { name: 'Apto para niños', icon: Baby, category: 'Familiar' },
  'familia': { name: 'Familiar', icon: Users, category: 'Familiar' },
  'family': { name: 'Familiar', icon: Users, category: 'Familiar' },
  
  // Events
  'eventos': { name: 'Salón de eventos', icon: PartyPopper, category: 'Eventos' },
  'events': { name: 'Salón de eventos', icon: PartyPopper, category: 'Eventos' },
  'conferencias': { name: 'Salas de conferencias', icon: Briefcase, category: 'Eventos' },
  'conference': { name: 'Salas de conferencias', icon: Briefcase, category: 'Eventos' },
  'reuniones': { name: 'Salas de reuniones', icon: Briefcase, category: 'Eventos' },
  'meeting': { name: 'Salas de reuniones', icon: Briefcase, category: 'Eventos' },
};

export function extractAmenitiesFromText(text: string | undefined): AmenityCategory[] {
  if (!text) return [];
  
  const normalizedText = text.toLowerCase();
  const foundAmenities = new Map<string, Amenity>();
  
  // Check for each amenity keyword in the text
  Object.entries(amenityKeywords).forEach(([keyword, amenity]) => {
    if (normalizedText.includes(keyword)) {
      // Use amenity name as key to avoid duplicates
      if (!foundAmenities.has(amenity.name)) {
        foundAmenities.set(amenity.name, amenity);
      }
    }
  });
  
  // Group amenities by category
  const categoriesMap = new Map<string, Amenity[]>();
  
  foundAmenities.forEach((amenity) => {
    const existing = categoriesMap.get(amenity.category) || [];
    existing.push(amenity);
    categoriesMap.set(amenity.category, existing);
  });
  
  // Convert to array and sort
  const categories: AmenityCategory[] = Array.from(categoriesMap.entries()).map(
    ([name, amenities]) => ({
      name,
      amenities: amenities.sort((a, b) => a.name.localeCompare(b.name)),
    })
  );
  
  // Sort categories by name
  return categories.sort((a, b) => a.name.localeCompare(b.name));
}
